import { css } from '@emotion/react';
import { validatePhoneNumber } from '@onward-delivery/core';
import { colors } from '@/styles/';

export { validatePhoneNumber };

export const PHONE_WARNING_MSG = 'Unrecognized phone number format';

// A phone we cannot parse is a warning, never a blocker: the number saves as entered
// and the field is highlighted so an operator can correct it if it matters. An absent
// phone is not a warning — there is nothing to correct.
export const hasPhoneWarning = (phone) => !!phone && !validatePhoneNumber(phone);

// Non-blocking warning styling for a phone field: gold outline and helper text, matching
// the `validationWarning` convention in styles/blocks. Spread onto a MUI TextField LAST so
// it wins over the field's own helperText. An error always outranks a warning, so callers
// gate on `!error`.
export const phoneWarningProps = (showWarning) =>
    showWarning
        ? {
              helperText: PHONE_WARNING_MSG,
              FormHelperTextProps: { style: { color: colors.golds[2] } },
              css: css`
                  .MuiOutlinedInput-notchedOutline {
                      border-color: ${colors.golds[2]};
                  }
              `,
          }
        : {};
